import { render, staticRenderFns } from "./AppointmentEditForm.vue?vue&type=template&id=675d1b81&scoped=true"
import script from "./AppointmentEditForm.vue?vue&type=script&lang=ts"
export * from "./AppointmentEditForm.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentEditForm.vue?vue&type=style&index=0&id=675d1b81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675d1b81",
  null
  
)

export default component.exports